import React, { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Link, useParams } from "react-router-dom";
import { printsData } from "../components/data/printsData";
import canvasPrint from "../assets/printsPageAssets/print.png";
import framedCanvas from "../assets/printsPageAssets/framedCanvas.jpg";
import stretchedCanvas from "../assets/printsPageAssets/stretchedCanvas.jpg";
import { motion, useAnimation, useInView } from "framer-motion";
import frameBlack from "../assets/printsPageAssets/frameBlack.avif";
import frameWhite from "../assets/printsPageAssets/frameWhite.avif";
import frameGold from "../assets/printsPageAssets/frameGold.avif";
import frameWoody from "../assets/printsPageAssets/frameWoody.jpg";
import { CartContext } from "../CartContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import { getPrice } from "../components/getPrice";

const PrintPage = () => {
  // const cart = useContext(CartContext);
  // const { title } = useParams();
  // const [canvasType, setCanvasType] = useState("print");
  // const [selectedSize, setSelectedSize] = useState("40x60");
  // const [price, setPrice] = useState(89.99);
  // const [frameColor, setFrameColor] = useState("black");
  // const [quantity, setQuantity] = useState(1);
  const { t } = useTranslation();
  const cart = useContext(CartContext);
  const { title } = useParams();
  const [canvasType, setCanvasType] = useState("print");
  const sizes1Piece = ["70x50", "80x60", "100x70", "120x80", "140x80"];
  const sizes3Pieces = ["70x50", "80x60", "100x70"];

  const sizeOptions =
    printsData.pieces === "1piece" ? sizes1Piece : sizes3Pieces;
  const [selectedSize, setSelectedSize] = useState(sizeOptions[0]);

  const [price, setPrice] = useState(89.99);
  const [frameColor, setFrameColor] = useState("black");
  const [quantity, setQuantity] = useState(1);

  const product = printsData.find((p) => p.title === title); // Get full product
  const pieces = product?.pieces || "1piece";

  useEffect(() => {
    const calculatedPrice = getPrice(canvasType, selectedSize, pieces);
    setPrice(calculatedPrice);
  }, [canvasType, selectedSize, pieces]);

  localStorage.setItem("cmimi", price.toString());
  localStorage.setItem("canvasType", canvasType.toString());
  localStorage.setItem("selectedSize", selectedSize.toString());
  localStorage.setItem("frameColor", frameColor.toString());

  const handleAddToCart = (product) => {
    const itemPrice = getPrice(canvasType, selectedSize, pieces);

    cart.addOneToCart(product.id, {
      canvasType,
      selectedSize,
      quantity,
      title: product.title,
      price: itemPrice,
      image: product.image,
      pieces: pieces,
    });
  };

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const animation = useAnimation();

  useEffect(() => {
    if (isInView) {
      animation.start("visible");
    }
    // eslint-disable-next-line
  }, [isInView]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Print Page | BP11 ArtPrints";
  }, []);
  return (
    <Container>
      {printsData
        .filter((item) => item.title === title)
        .map((print) => (
          <div className="top">
            <span className="navigation" key={print.id}>
              <Link to={"/"} className="link-styles">
                <h4>Home</h4>
              </Link>
              &gt;{" "}
              <Link to={"/portfolio"} className="link-styles">
                <h4>Prints</h4>
              </Link>
              &gt;{" "}
              <Link to={`/portfolio/${print.title}`} className="link-styles">
                <h3>{print.title}</h3>
              </Link>
            </span>
            <motion.img
              ref={ref}
              variants={{
                hidden: { opacity: 0, x: -100 },
                visible: { opacity: 1, x: 0 },
              }}
              transition={{ duration: 0.3 }}
              initial="hidden"
              animate={animation}
              className={canvasType}
              id="image"
              src={print.image}
              alt=""
            />
            <motion.div
              ref={ref}
              variants={{
                hidden: { opacity: 0, y: 100 },
                visible: { opacity: 1, y: 0 },
              }}
              transition={{ duration: 0.3, delay: 0.7 }}
              initial="hidden"
              animate={animation}
              className="details"
            >
              <h1>{print.title}</h1>
              <h2>{price}€</h2>
              <h3>
                {t("material")}:{" "}
                {canvasType === "print" && <span>{t("canvasPrint")}</span>}
                {canvasType === "stretched" && <span>{t("streched")}</span>}
                {canvasType === "framed" && <span>{t("framed")}</span>}
              </h3>
              <div className="printTypes">
                <span
                  onClick={() => setCanvasType("print")}
                  className={canvasType === "print" ? "active" : ""}
                >
                  <img src={canvasPrint} alt="" />
                  <h4>{t("canvasPrint")}</h4>
                </span>
                {localStorage.setItem("image", print.image)}
                <span
                  onClick={() => setCanvasType("stretched")}
                  className={canvasType === "stretched" ? "active" : ""}
                >
                  <img src={stretchedCanvas} alt="" />
                  <h4>{t("streched")}</h4>
                </span>
                <span
                  onClick={() => setCanvasType("framed")}
                  className={canvasType === "framed" ? "active" : ""}
                >
                  <img src={framedCanvas} alt="" />
                  <h4>{t("framed")}</h4>
                </span>
              </div>
              <h3>
                {t("size")}: <span>{selectedSize}cm</span>
              </h3>
              {print.pieces === "1piece" ? (
                <div className="size">
                  <h2
                    className={selectedSize === "70x50" ? "active" : ""}
                    onClick={() => setSelectedSize("70x50")}
                  >
                    70x50cm
                  </h2>
                  <h2
                    className={selectedSize === "80x60" ? "active" : ""}
                    onClick={() => setSelectedSize("80x60")}
                  >
                    80x60cm
                  </h2>
                  <h2
                    className={selectedSize === "100x70" ? "active" : ""}
                    onClick={() => setSelectedSize("100x70")}
                  >
                    100x70cm
                  </h2>
                  <h2
                    className={selectedSize === "120x80" ? "active" : ""}
                    onClick={() => setSelectedSize("120x80")}
                  >
                    120x80cm
                  </h2>
                  <h2
                    className={selectedSize === "140x80" ? "active" : ""}
                    onClick={() => setSelectedSize("140x80")}
                  >
                    140x80cm
                  </h2>
                </div>
              ) : (
                <div className="size">
                  <h2
                    className={selectedSize === "70x50" ? "active" : ""}
                    onClick={() => setSelectedSize("70x50")}
                  >
                    70x50cm
                  </h2>
                  <h2
                    className={selectedSize === "80x60" ? "active" : ""}
                    onClick={() => setSelectedSize("80x60")}
                  >
                    80x60cm
                  </h2>
                  <h2
                    className={selectedSize === "100x70" ? "active" : ""}
                    onClick={() => setSelectedSize("100x70")}
                  >
                    100x70cm
                  </h2>
                </div>
              )}
              {/* {canvasType === "framed" && (
                <div className="frameColor">
                  <img
                    onClick={() => setFrameColor("black")}
                    className={frameColor === "black" ? "active" : ""}
                    src={frameBlack}
                    alt=""
                  />
                  <img
                    onClick={() => setFrameColor("white")}
                    className={frameColor === "white" ? "active" : ""}
                    src={frameWhite}
                    alt=""
                  />
                  <img
                    onClick={() => setFrameColor("gold")}
                    className={frameColor === "gold" ? "active" : ""}
                    src={frameGold}
                    alt=""
                  />
                  <img
                    onClick={() => setFrameColor("woody")}
                    className={frameColor === "woody" ? "active" : ""}
                    src={frameWoody}
                    alt=""
                  />
                </div>
              )} */}
              <div className="cartBtns">
                <button
                  className="checkoutBtn"
                  onClick={() => handleAddToCart(print)}
                >
                  {t("addToCart")}
                </button>
                {/* <button
                  className="checkoutBtn"
                  onClick={() =>
                    cart.removeOneFromCart(print.id, {
                      canvasType,
                      selectedSize,
                      quantity,
                    })
                  }
                >
                  Remove from cart
                </button> */}
                <ToastContainer />
              </div>
            </motion.div>
          </div>
        ))}
    </Container>
  );
};
const Container = styled.div`
  background: var(--primaryBackgroundColor);
  color: var(--fontPrimaryColor);
  .top {
    padding: 7em 7%;
    background: var(--primaryBackgroundColor);
    color: var(--fontPrimaryColor);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 2em;
    position: relative;
    .navigation {
      position: fixed;
      display: flex;
      align-items: center;
      gap: 10px;
      top: 4.7em;
      left: 10%;
      h4 {
        color: var(--fondSecondaryColor);
        font-weight: 300;
      }
      h3 {
        font-size: 17px;
        font-weight: 500;
      }
    }
    .bgImg {
      position: fixed;
      height: auto;
      right: 7%;
      top: 7em;
      width: 22vw;
      opacity: 0.2;
      transform: rotate(10deg);
      filter: grayscale(100%);
      z-index: -1;
    }
    #image {
      width: 49%;
      flex: 1;
      max-width: 800px;
    }
    .framed {
      width: 49%;
      position: sticky;
      top: 7em;
      z-index: 1;
      border: 10px outset black;
      box-shadow: 0 4px 8px 1px var(--fontSecondaryColor);
    }
    .stretched {
      width: 49%;
      position: sticky;
      top: 7em;
      z-index: 1;
      box-shadow: 0 4px 8px 1px var(--fontSecondaryColor);
      transform: rotateY(45deg) rotateX(130deg) perspective(4999px);
      box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.3);
      transform-style: preserve-3d;
    }
    .print {
      width: 49%;
      max-width: 900px;
      position: sticky;
      top: 7em;
      z-index: 1;
      /* box-shadow: 0 4px 8px 1px var(--fontSecondaryColor); */
    }
    .details {
      display: flex;
      flex-direction: column;
      gap: 10px;
      h4 {
        font-weight: 300;
        color: var(--fontSecondaryColor);
      }
      h1 {
        font-weight: 600;
        text-transform: capitalize;
      }
      h2 {
        font-weight: 400;
      }
      h3 {
        font-weight: 400;
        span {
          color: var(--fontSecondaryColor);
          font-weight: 300;
        }
      }
      .printTypes {
        display: flex;
        align-items: center;
        gap: 1em;
        .active {
          box-shadow: 0 4px 12px 4px var(--shadowColor);
          border-radius: 10px;
        }
        span {
          width: 160px;
          transition: 0.4s;
          cursor: pointer;
          img {
            border-radius: 0 0 10px 10px;
            width: 100%;
            box-shadow: 0 0 0 0;
          }
          h4 {
            text-align: center;
            padding: 7px 14px;
            text-transform: uppercase;
          }
          &:hover {
            transform: scale(1.04);
          }
        }
      }
      .size {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 7px;
        h2 {
          font-size: 17px;
          background: var(--shadowColor);
          color: var(--primaryBackgroundColor);
          padding: 7px 10px;
          border-radius: 12px;
          cursor: pointer;
          transition: 0.4s;
          &:hover {
            background: var(--fontSecondaryColor);
          }
        }
        .active {
          background: var(--fontPrimaryColor);
          &:hover {
            background: var(--fontPrimaryColor);
          }
        }
      }
      .frameColor {
        display: flex;
        align-items: center;
        gap: 10px;
        img {
          width: 20%;
          max-width: 150px;
          transition: 0.4s;
          cursor: pointer;
          &:hover {
            box-shadow: 0 4px 10px 5px var(--shadowColor);
          }
        }
        .active {
          border: 2px solid var(--fontPrimaryColor);
          box-shadow: 0 4px 10px 5px var(--shadowColor);
          transform: scale(1.06);
        }
      }
      .counter {
        display: flex;
        align-items: center;
        gap: 8px;
        button {
          font-size: 24px;
          width: 30px;
          height: 30px;
          border: none;
          background: var(--fontPrimaryColor);
          color: var(--primaryBackgroundColor);
          border-radius: 7px;
          cursor: pointer;
          transition: 0.4s;
          &:hover {
            background-color: var(--fontSecondaryColor);
          }
        }
        input {
          border: 1px solid var(--fontSecondaryColor);
          outline: none;
          border-radius: 4px;
          width: 50px;
          height: 30px;
        }
      }
      .cartBtns {
        display: flex;
        gap: 1em;
        .checkoutBtn {
          align-self: flex-start;
          font-family: "Montserrat", sans-serif;
          font-size: 17px;
          padding: 12px 17px;
          border: none;
          background: var(--fontPrimaryColor);
          color: var(--primaryBackgroundColor);
          border-radius: 20px;
          z-index: 1;
          margin: 14px 0 7px 0;
          cursor: pointer;
          transition: 0.4s;
          &:hover {
            background-color: var(--fontSecondaryColor);
          }
        }
        :nth-child(2) {
          background: var(--shadowColor);
          color: var(--fontPrimaryColor);
          &:hover {
            background: var(--secondaryBackgroundColor);
          }
        }
      }

      .frameTypes {
        display: flex;
        flex-direction: column;
        gap: 2em;
        span {
          h3 {
            font-weight: 600;
          }
          p {
            color: var(--fontSecondaryColor);
            font-weight: 300;
            margin-top: 8px;
          }
        }
      }
    }
    @media (max-width: 1040px) {
      .details {
        .printTypes {
          span {
            width: 110px;
          }
        }
      }
    }
    @media (max-width: 750px) {
      flex-direction: column;
      .navigation {
        position: absolute;
      }
      #image {
        width: 100%;
      }
      .stretched {
        margin: auto;
        width: 900px;
        position: unset;
      }
      .framed {
        margin: auto;
        width: 100%;
        position: unset;
      }
      .print {
        margin: auto;
        width: 100%;
        position: unset;
      }
      .details {
        align-items: center;
        .printTypes {
          gap: 10px;
          .active {
            box-shadow: 0 2px 7px 2px var(--shadowColor);
          }
          span {
            width: 30%;
            h4 {
              font-size: 3vw;
            }
          }
        }
        .size {
          justify-content: center;
          h2 {
            width: 48%;
            text-align: center;
          }
        }
        .checkoutBtn {
          align-self: center;
          margin-bottom: 2em;
        }
        .frameTypes {
          align-items: center;
          text-align: center;
        }
      }
    }
  }
  .recommandations {
    h2 {
      text-align: center;
      font-weight: 400;
    }
    .swiper {
      margin: 1em 7%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 3em 2%;
      padding: 1em 2em 4em 2em;
      border-radius: 30px;
      z-index: 2;
      .slide {
        width: 350px;

        text-align: center;
        border-radius: 20px 20px;
        z-index: 2;
        img {
          padding: 1px 1px 0 1px;
          width: 100%;
          object-fit: cover;
          border-radius: 20px 20px 0 0;
        }
        span {
          display: flex;
          flex-direction: column;
          align-items: center;
          border-radius: 0 0 20px 20px;
          padding: 14px 10px;
          h3 {
            color: #807973;
            font-weight: 500;
          }
          h4 {
            font-weight: 400;
            margin-top: 10px;
          }
        }
      }
    }
  }
`;

export default PrintPage;
